// The ui/Price component renders the currency symbol and unit separately, so
// this formats only the grouped amount (e.g. 1000 -> "1,000"), preserving the
// existing visual.
const grouped = new Intl.NumberFormat("en-AU", { maximumFractionDigits: 0 });

export function formatAmount(amount: number): string {
  return grouped.format(amount);
}

// The Price component renders the currency glyph separately from the amount,
// so we map the CMS currency code to its symbol. Unknown/missing codes fall
// back to "$".
const CURRENCY_SYMBOLS: Record<string, string> = { AUD: "$" };

export function currencySymbol(code: string | undefined): string {
  return (code && CURRENCY_SYMBOLS[code]) || "$";
}

// USD is an informational subtitle next to the AUD price (payment stays AUD).
// `rate` is the admin-set AUD→USD multiplier; a missing/zero rate hides the
// subtitle (returns null), so prod never shows a bogus "$0 USD".
export function usdAmount(aud: number, rate: number | undefined): number | null {
  if (!rate) return null;
  return Math.round(aud * rate);
}

// "≈" marks the figure as approximate so it never reads as a payable price.
// The $ / USD glyphs are currency formatting (like currencySymbol), not CMS copy.
export function formatUsd(usd: number): string {
  return `≈ $${formatAmount(usd)} USD`;
}
